export class University {
    constructor(
        public id: string,
        public name: string,
        public exchangePrograms: ExchangeProgram[]
    ) {}
}

export class ExchangeProgram {
    constructor(
        public id: string,
        public description: string,
        public beginDate: string,
        public endDate: string,
        public programOfStudyId: string
    ) {}
}